export function allEqual<T>(items: T[]): boolean {
  if (items.length === 0) {
    return true;
  }
  const first = items[0];
  return items.every((item) => item === first);
}
